import { request } from './axios.js'

export let addMotorShowApi = (data) =>
  request({ data, url: '/webapp/api/motorShowCus/add'})


export let motorShowCusRentCarUserInfoApi = (data) =>
  request({ data, url: '/webapp/api/motorShowCus/userInfo'})


// export let timePeriodListApi = (data) =>
//   request({ data, url: '/webapp/api/icaurRentCar/timePeriodList'})

// RTS 管理后台 - 登录验证
// export let rtsLoginApi = (data) =>
//   request({ data, url: '/webapp/api/icaurRentCar/rtsLogin' })


// RTS 管理后台 - 留资列表（分页+筛选）
export let rtsLeadListApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/leadList' })

// RTS 管理后台 - 数据统计
export let rtsStatisticsApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/statistics' })

// RTS 管理后台 - 导出Excel
export let exportExcelApi = (params) =>
  request({ method: 'get', url: '/webapp/api/motorshow/exportExcel', params })


export let salesManListApi = (params) =>
  request({ method: 'get', url: '/webapp/api/motorShowCus/salesManList', params })

// RTS 管理后台 - 活动管理
export let activityListApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityList' })

export let activityAddApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityAdd' })

export let activityUpdateApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityUpdate' })

export let activityDeleteApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityDelete' })

// RTS 管理后台 - 当前活动配置
export let currentUrlListApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/currentUrl' })

export let currentUrlAddApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/currentUrlAdd' })

export let currentUrlUpdateApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/currentUrlUpdate' })

export let currentUrlDeleteApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/currentUrlDelete' })

// RTS 管理后台 - 活动页面构建器（占位接口，待后端就绪后对接）
// 活动页面详情
export let activityPageDetailApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityPageDetail' })

// 活动页面保存（新增/编辑）
export let activityPageSaveApi = (data) =>
  request({ data, url: '/webapp/api/motorshow/activityPageSave' })

// 图片上传（multipart/form-data）
export let uploadImageApi = (formData) =>
  request({
    data: formData,
    url: '/webapp/api/motorshow/uploadImage',
    headers: { 'Content-Type': 'multipart/form-data' },
  })

